import { Space } from "antd"
import { SvgIcAuthenticator } from "components/svg"
import { useTranslation } from "react-i18next"
import cx from "clsx"
import styles from "../index.module.less"
import theme from "utils/themeVars"

const { getDeviceInoHash, performEncryption } = require("configs/utils")
const { useState } = require("react")
const { useVerifyGAuthMutation } = require("../api")
const { notification, Title, Text, Card, OtpInputField, Button } = require("components/common")

const GoogleAuthorizationFlow = ({ challengeUserToLogin, setCurrentState, userState }) => {
  const { t } = useTranslation()
  const [verifyGAuth, { isLoading: isLoadingGAuth }] = useVerifyGAuthMutation()

  const [googleOTP, setGoogleOTP] = useState()

  const verifyGoogleAuthenticator = async () => {
    const response = await verifyGAuth({
      a: performEncryption(userState?.uuid),
      b: getDeviceInoHash(false, userState?.uuid),
      token: googleOTP,
    })
    if (response?.error) {
      notification.error({ message: response?.error?.message })
    } else if (response?.data?.tokenVerified) {
      notification.success({ message: t("Authentication verified successfully") })
      challengeUserToLogin(userState?.uuid)
      setCurrentState("default")
    }
  }
  return (
    <Space direction="vertical" align="center" size={24}>
      <div className="text-center">
        <Space size={6} className="w-100 mbe-8" align="baseline" style={{ justifyContent: "center" }}>
          <Title level={2} className="text-center mbe-0 bold">
            {t("Google Authenticator Verification")}
          </Title>
          <SvgIcAuthenticator />
        </Space>

        <Text type="secondary" style={{ maxWidth: 350 }}>
          {t("Please open your Google Authenticator app and enter the 6-digit code to complete your login.")}
        </Text>
      </div>

      <div>
        <Text className="mbe-16" type="secondary">
          {t("Steps to follow")}:
        </Text>
        <ol className={cx(styles.lists, "gray-900 mbe-0")}>
          <li>
            {t("Open the ")} <strong>{t("Google Authenticator")}</strong> {t(" app on your mobile device.")}
          </li>
          <li>
            {t("Find the code associated with your account. It refreshes every ")}
            <strong>30 {t("seconds")}.</strong>
          </li>
          <li>
            {t("Enter the ")} <strong>{t("6-digit code")}</strong>
            {t(" in the field below.")}
          </li>
        </ol>
      </div>
      <Space size={20} direction="vertical">
        <OtpInputField
          isDisabled={isLoadingGAuth}
          otp={googleOTP}
          setOtp={setGoogleOTP}
          index={6}
          customStyle={{
            width: 54,
            height: 54,
            fontSize: "18px",
          }}
        />
        <Button
          type="primary"
          text={t("Verify")}
          size="large"
          onClick={() => {
            verifyGoogleAuthenticator()
          }}
          loading={isLoadingGAuth}
          block
        />
      </Space>
    </Space>
  )
}
export default GoogleAuthorizationFlow
